import React from "react";

class NotificationService {
  registerRef(ref) {
    this.ref = ref;
  }

  notifyError(message) {
    this.notify(message, "danger");
  }

  notifyWarn(message) {
    this.notify(message, "warning");
  }

  notifySuccess(message) {
    this.notify(message, "success");
  }

  notify(message, type = "primary") {
    if (this.ref && this.ref.current) {
      let options = {};
      options = {
        place: "tr",
        message: (
          <div>
            <div>{message}</div>
          </div>
        ),
        type: type,
        icon: "nc-icon nc-bell-55",
        autoDismiss: 4,
      };
      this.ref.current.notificationAlert(options);
    }
  }
}

export const notificationService = new NotificationService();
